import axios from "axios";
import { API_SUPER_ADMIN_URL } from "../config/config";

const apiClient = axios.create({
  baseURL: API_SUPER_ADMIN_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default apiClient;
